export const SWIMLANE_HEADER_ID = 'polaris-ideas_ui_view-content_swimlane-header';
export const HEADER_HEIGHT = 36;
